import { Alert, Avatar, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, styled, Typography } from "@mui/material"
import { plural } from "../../../utils/utilityFunctions";
import { Box } from "@mui/system";
import AlertLoading from "../../navigation/AlertLoading";
import { createSearchParams, useNavigate } from "react-router-dom";
import CabinIcon from '@mui/icons-material/Cabin';
import IcpInspectionStatusChip from "../../styled/IcpInspectionStatusChip";
import ICPNumberChip from "../../styled/ICPNumberChip";
import WorkOrderDate from "../../styled/WorkOrderDate";
import { hikoGeneratePath } from "@northpowerdev/np-react-utils";

const StyledListItemButton = styled(ListItemButton)(({theme}) => {
    return ({
        [theme.breakpoints.down('md')]: {
          paddingLeft: '6px',
          paddingRight: '6px',
        },
        [theme.breakpoints.down('sm')]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
    })
})

/**
 * 
 * @param {object} props {title: <string>, inspections: {object[]}}
 * @returns JSX Component
 */
export default function IcpInspectionList({title, inspections, loading}) {
    const navigate = useNavigate()
      
    const handleViewIcpInspection = (workOrderId, icpNumber) => {
        console.log('handleViewIcpInspection', workOrderId)
        const urlString = '/connect/icp_inspection_details'
        const params = {work_order_id: workOrderId, icp_number: icpNumber}
        // const path = generatePath(":urlString?:queryString", { urlString, queryString: createSearchParams(params).toString() });
        const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
        navigate(path)
    }

    if (loading) {
        return <AlertLoading spinner={true} />
    }
    if (!inspections?.length) {
        return <Alert severity="info">No {title} ICP inspections found.</Alert>
    }
    return (
        <Box>
            <Typography variant="body1">{inspections.length} ICP inspection{plural(inspections.length)} found</Typography>
            {
                (title ==='Livening Not Ready')
                &&
                <Alert severity="warning">Northpower has approved livening to the network but the Retailer has not accepted the ICP.</Alert>
            }    
            {
                (title ==='Livening Ready')
                &&
                <Alert severity="info">Both Northpower and the Retailer have approved and accepted the ICP.</Alert>
            }       
            <List>
                {
                    inspections.map((thisApplication) => {
                        const propertyNameAndLotDP = [thisApplication?.propertyName, thisApplication?.lotDPFormatted].filter(v => v).join(', ') // filter() removes empty strings & nulls.
                        return (
                            <ListItem key={thisApplication.workOrderId} sx={{px: 0}}>
                                <StyledListItemButton alignItems="flex-start" onClick={() => handleViewIcpInspection(thisApplication.workOrderNumber, thisApplication.icpNo)}>
                                    <ListItemAvatar>
                                        <Avatar alt={thisApplication.workType}><CabinIcon /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                        <>
                                            <Typography variant="h6">
                                                {thisApplication.streetAddress}
                                            </Typography>
                                            {
                                                propertyNameAndLotDP
                                                &&
                                                <Typography variant="body2"><strong>{propertyNameAndLotDP}</strong></Typography>
                                            }
                                            <Typography variant="h6" sx={{mb:1}}>
                                                <ICPNumberChip sx={{fontSize: '0.75em'}} icpNumber={thisApplication.icpNo} />
                                            </Typography>
                                            <Typography variant="body2"><strong>{thisApplication.workType}</strong> | Work order: <strong>{thisApplication.workOrderNumber}</strong></Typography>
                                            <IcpInspectionStatusChip sx={{my:1}} status={thisApplication.workOrderStatus} />
                                            <Typography variant="body2">
                                                <strong>{thisApplication?.networkApprovedContractor?.name || <em>No Contractor</em>}</strong>
                                                <WorkOrderDate prefix=' | Scheduled: ' isoDateString={thisApplication?.scheduledDate} boldDate={true} />
                                                <WorkOrderDate prefix=' | Connected: ' isoDateString={thisApplication?.connectionDate} boldDate={true} />
                                            </Typography>
                                        </>
                                        }
                                    />
                                </StyledListItemButton>
                            </ListItem>
                        )
                    })
                }

            </List>
        </Box>
    )
}